document.addEventListener('DOMContentLoaded', function() {

    // Sync heart buttons with saved wishlist state on page load
    function syncWishlistButtons() {
        const wishlist = JSON.parse(localStorage.getItem('shopify_wishlist') || '[]');
        document.querySelectorAll('.wishlist-heart-btn').forEach(btn => {
            const productId = btn.dataset.productId;
            if (wishlist.find(item => item.id === productId)) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }
    syncWishlistButtons();
    setTimeout(syncWishlistButtons, 1000);
    setTimeout(syncWishlistButtons, 3000);

   window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            syncWishlistButtons();
            if (typeof window.updateWishlistCount === 'function') {
                window.updateWishlistCount();
            }
        }
    });
    
    // =================================
    // 1. HEART ANIMATION ON WISHLIST - FIXED with Event Delegation
    // =================================
    document.addEventListener('click', function(e) {
        const wishlistBtn = e.target.closest('.wishlist-heart-btn');
        if (!wishlistBtn) return; // Not a wishlist button, ignore

        e.preventDefault();
        e.stopPropagation();

        const product = {
            id: wishlistBtn.dataset.productId,
            title: wishlistBtn.dataset.productTitle,
            image: wishlistBtn.dataset.productImage,
            price: wishlistBtn.dataset.productPrice,
            url: '/products/' + wishlistBtn.dataset.productHandle,
            variant_id: wishlistBtn.dataset.productId
        };

        let wishlist = JSON.parse(localStorage.getItem('shopify_wishlist') || '[]');
        const index = wishlist.findIndex(item => item.id === product.id);
        const willBeActive = index === -1;

        if (index > -1) {
            wishlist.splice(index, 1);
        } else {
            wishlist.push(product);
        }

        localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));

        if (willBeActive) {
            wishlistBtn.classList.add('active');
        } else {
            wishlistBtn.classList.remove('active');
        }

        wishlistBtn.classList.add('animating');

        if (willBeActive) {
            createFlyingHeart(e.pageX, e.pageY);
        }

        setTimeout(() => {
            wishlistBtn.classList.remove('animating');
        }, 400);

        if (typeof window.updateWishlistCount === 'function') {
            window.updateWishlistCount();
        }
    }, true); // Use capture phase to ensure it runs

    function createFlyingHeart(x, y) {
        const heart = document.createElement('div');
        heart.className = 'flying-heart';
        heart.innerHTML = '❤️';
        heart.style.left = x + 'px';
        heart.style.top = y + 'px';
        document.body.appendChild(heart);
        
        setTimeout(() => {
            heart.remove();
        }, 800);
    }
    
    // =================================
    // 2. COLOR VARIANT FUNCTIONALITY
    // =================================
    function initializeColorVariants() {
        const productCards = document.querySelectorAll('.card-wrapper');
        
        productCards.forEach(card => {
            // This is where you'd fetch variant data from your product
            // For demo, I'm showing how it would work
            const variantColors = card.dataset.variants;
            if (variantColors) {
                const colors = JSON.parse(variantColors);
                const colorContainer = document.createElement('div');
                colorContainer.className = 'variant-colors';
                
                colors.forEach(color => {
                    const dot = document.createElement('span');
                    dot.className = 'color-dot';
                    if (color.active) dot.classList.add('active');
                    if (color.outOfStock) dot.classList.add('out-of-stock');
                    dot.style.background = color.hex;
                    dot.dataset.colorName = color.name;
                    dot.dataset.image = color.image;
                    
                    dot.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        if (!this.classList.contains('out-of-stock')) {
                            // Remove active from siblings
                            this.parentElement.querySelectorAll('.color-dot').forEach(d => {
                                d.classList.remove('active');
                            });
                            this.classList.add('active');
                            
                            // Change product image
                            const productImage = card.querySelector('.card__media img');
                            if (productImage && this.dataset.image) {
                                productImage.src = this.dataset.image;
                            }
                        }
                    });
                    
                    colorContainer.appendChild(dot);
                });
                
                // Insert after product title
                const cardContent = card.querySelector('.card__content');
                const priceWrapper = card.querySelector('.price-cart-wrapper');
                cardContent.insertBefore(colorContainer, priceWrapper);
            }
        });
    }
    
    // Initialize variants (you'll need to add data-variants to your product cards)
    initializeColorVariants();
    
    // =================================
    // 3. ADD TO CART ANIMATION - FIXED with Event Delegation
    // =================================
    // Use event delegation for cart buttons too
    document.addEventListener('click', function(e) {
        const cartBtn = e.target.closest('.cart-icon-btn');
        if (!cartBtn) return; // Not a cart button, ignore

        // Don't prevent default if there's an onclick handler
        if (!cartBtn.hasAttribute('onclick')) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Add pulse animation
        cartBtn.classList.add('pulse');

        // Haptic feedback (if available)
        if (window.navigator && window.navigator.vibrate) {
            window.navigator.vibrate(50);
        }

        // Create "Added!" popup
        const popup = document.createElement('div');
        popup.className = 'added-to-cart-popup';
        popup.textContent = 'Added! ✓';
        cartBtn.appendChild(popup);

        // Change to success state temporarily
        setTimeout(() => {
            cartBtn.classList.add('success');
            const originalIcon = cartBtn.innerHTML;
            cartBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-width="2" d="M5 10l3 3 7-7"/></svg>';

            setTimeout(() => {
                cartBtn.classList.remove('success');
                cartBtn.innerHTML = originalIcon;
            }, 1000);
        }, 200);

        // Clean up
        setTimeout(() => {
            cartBtn.classList.remove('pulse');
            if (popup && popup.parentNode) {
                popup.remove();
            }
        }, 1000);

        // Here you'd add the actual add to cart functionality if no onclick
        // Example: addToCart(productId, variantId);
    }, true); // Use capture phase
    // =================================
    // 5. PULL TO REFRESH
    // =================================
    let startY = 0;
    let pullDistance = 0;
    let isPulling = false;
    const PULL_THRESHOLD = 100;
    
    // Create pull to refresh element
    const pullContainer = document.createElement('div');
    pullContainer.className = 'pull-to-refresh-container';
    pullContainer.innerHTML = `
        <div class="pull-to-refresh-content">
            <span class="pull-arrow">↓</span>
            <span class="refresh-text">Pull to discover more</span>
            <span class="refresh-spinner"></span>
        </div>
    `;
    document.body.appendChild(pullContainer);
    
    const refreshText = pullContainer.querySelector('.refresh-text');
    const refreshMessages = [
        'Finding fresh products...',
        'Discovering new items...',
        'Loading amazing deals...',
        'Refreshing your feed...'
    ];
    
    // Touch events for pull to refresh
    document.addEventListener('touchstart', function(e) {
        if (window.scrollY === 0) {
            startY = e.touches[0].pageY;
            isPulling = true;
        }
    });
    
    document.addEventListener('touchmove', function(e) {
        if (!isPulling) return;
        
        pullDistance = e.touches[0].pageY - startY;
        
        if (pullDistance > 0 && window.scrollY === 0) {
            e.preventDefault();
            
            pullContainer.classList.add('pulling');
            pullContainer.style.transform = `translateY(${Math.min(pullDistance * 0.5, 60)}px)`;
            
            if (pullDistance > PULL_THRESHOLD) {
                pullContainer.classList.add('can-refresh');
                refreshText.textContent = 'Release to refresh';
            } else {
                pullContainer.classList.remove('can-refresh');
                refreshText.textContent = 'Pull to discover more';
            }
        }
    });
    
    document.addEventListener('touchend', function() {
        if (!isPulling) return;
        
        if (pullDistance > PULL_THRESHOLD) {
            // Trigger refresh
            pullContainer.classList.add('refreshing');
            pullContainer.classList.remove('can-refresh');
            refreshText.textContent = refreshMessages[Math.floor(Math.random() * refreshMessages.length)];
            
            // Simulate refresh (replace with actual refresh logic)
            setTimeout(() => {
                location.reload();
            }, 1500);
        } else {
            pullContainer.classList.remove('pulling');
            pullContainer.style.transform = '';
        }
        
        isPulling = false;
        pullDistance = 0;
    });
    
    // =================================
    // 6. MOBILE OPTIMIZATIONS
    // =================================
    
    // Prevent zoom on double tap (iOS) - but allow button clicks
    let lastTouchEnd = 0;
    document.addEventListener('touchend', function(e) {
        // Don't prevent default on buttons or interactive elements
        if (e.target.closest('button, a, input, select, textarea')) {
            return;
        }

        const now = Date.now();
        if (now - lastTouchEnd <= 300) {
            e.preventDefault();
        }
        lastTouchEnd = now;
    }, false);
    
    // Smooth scroll to top button (optional)
    if (window.innerWidth <= 749) {
        const scrollTop = document.createElement('button');
        scrollTop.innerHTML = '↑';
        scrollTop.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            background:rgb(228, 214, 221);
            color: white;
            border: none;
            border-radius: 50%;
            font-size: 20px;
            z-index: 89;
            opacity: 0;
            transition: opacity 0.3s;
            display: none;
        `;
        document.body.appendChild(scrollTop);
        
        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollTop.style.display = 'block';
                scrollTop.style.opacity = '0.8';
            } else {
                scrollTop.style.opacity = '0';
                setTimeout(() => {
                    scrollTop.style.display = 'none';
                }, 300);
            }
        });
        
        scrollTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
});